<template>
	<dialog-slot
			:title="getTitle"
			@updateClose="closeDialog"
			@updateSave="onSave"
			width="1280px"
			apply-text="Save"
			is-btn-safe="getPermissionAction"
			:preloader="fuelPreloader"
	>
		<div class="addFuelWrapper">
			<div class="addFuel">
				<div class="addFuel_body">
					<div class="fieldBlock groupField">
						<div class="groupField_wrap">
							<field
									:class-error="$v.fuel_date && $v.fuel_date.$error"
									margin="0 0 10px 0"
									width="300px"
									type="text"
									label="Transaction date"
									placeholder="MM/DD/YYYY"
									display-format="YYYY-MM-DD hh:mm"
									:dateValue="fuel_date"
									@updateDate="onTime"
									is-date
									is-no-title
									is-required
							></field>
							<field
									:class-error="$v.driverId && $v.driverId.$error"
									margin="0 0 10px 10px"
									width="300px"
									label="Driver"
									placeholder="Select Driver"
									@updateAutocomplete="onAutocomplete($event, 'driverId')"
									:autocompleteValue="driverId"
									:items="drivers"
									:isClearable="false"
									is-autocomplete
									is-required
							></field>
							<field
									margin="0 0 10px 10px"
									width="300px"
									label="Customer and truck"
									placeholder=""
									:set-input-value="customerName"
									is-readonly
							></field>
							<field
									margin="0 0 10px 10px"
									width="300px"
									label="Card #"
									placeholder="Enter card"
									type="number"
									:setInputValue="card"
									@updateInput="onInput($event, 'card')"
							></field>
						</div>
						<div class="groupField_wrap">
							<field
									margin="0 0 10px 0"
									width="300px"
									label="Invoice"
									placeholder="Enter invoice"
									type="number"
									:setInputValue="invoice"
									@updateInput="onInput($event, 'invoice')"
							></field>
							<field
									margin="0 0 10px 10px"
									width="300px"
									label="Odometr"
									placeholder="Enter odometr"
									type="number"
									:setInputValue="odometr"
									@updateInput="onInput($event, 'odometr')"
							></field>
							<field
									margin="0 0 10px 10px"
									width="300px"
									label="State/prov"
									placeholder="Enter state/prov"
									:setInputValue="state"
									@updateInput="onInput($event, 'state')"
							></field>
							<field
									margin="0 0 10px 10px"
									width="300px"
									label="City"
									placeholder="Enter city"
									:setInputValue="city"
									@updateInput="onInput($event, 'city')"
							></field>
						</div>
						<div class="groupField_wrap">
							<field
									margin="0 0 10px 0"
									width="300px"
									label="Fees"
									placeholder="Enter fees"
									type="number"
									:setInputValue="fees"
									@updateInput="onInput($event, 'fees')"
							></field>
							<field
									margin="0 0 10px 10px"
									width="300px"
									label="Item"
									placeholder="Enter item"
									:setInputValue="item"
									@updateInput="onInput($event, 'item')"
							></field>
							<field
									margin="0 0 10px 10px"
									width="300px"
									label="Unit price"
									placeholder="Enter unit price"
									type="number"
									:setInputValue="unit"
									@updateInput="onInput($event, 'unit')"
							></field>
							<field
									margin="0 0 10px 10px"
									width="300px"
									label="Disc PPU"
									placeholder="Enter disc PPU"
									type="number"
									:setInputValue="ppu"
									@updateInput="onInput($event, 'ppu')"
							></field>
						</div>
						<div class="groupField_wrap align-start">
							<field
									margin="0 0 10px 0"
									width="300px"
									label="Disc cost"
									placeholder="Enter disc cost"
									type="number"
									:setInputValue="cost"
									@updateInput="onInput($event, 'cost')"
							></field>
							<field
									margin="0 0 10px 10px"
									width="300px"
									label="Disc AMT"
									placeholder="Enter disc AMT"
									:setInputValue="amt"
									@updateInput="onInput($event, 'amt')"
							></field>
							<field
									margin="0 0 10px 10px"
									width="300px"
									label="Disc type"
									placeholder="Enter disc type"
									:setInputValue="discType"
									@updateInput="onInput($event, 'discType')"
							></field>
							<field
									margin="0 0 10px 10px"
									width="300px"
									label="Currency"
									placeholder="Enter currency"
									:setInputValue="currency"
									@updateInput="onInput($event, 'currency')"
							></field>
						</div>
						<div class="groupField_wrap">
							<field
									margin="0 0 10px 0"
									width="300px"
									label="DB"
									placeholder="Enter DB"
									:setInputValue="db"
									@updateInput="onInput($event, 'db')"
							></field>
							<field
									:class-error="$v.gallons && $v.gallons.$error"
									margin="0 0 10px 10px"
									width="300px"
									label="Gallons"
									placeholder="Enter gallons"
									type="number"
									:setInputValue="gallons"
									@updateInput="onInput($event, 'gallons')"
									is-required
							></field>
							<field
									:class-error="$v.amount && $v.amount.$error"
									margin="0 0 10px 10px"
									width="300px"
									label="Amount"
									placeholder="Enter amount"
									type="number"
									:setInputValue="amount"
									@updateInput="onInput($event, 'amount')"
									is-required
							></field>
							<field
									margin="0 0 10px 10px"
									width="300px"
									label="Download check"
									placeholder="Add file"
									:setInputValue="file.name"
									:is-file-icon="!!file.value"
									color-icon="#19BC38"
									@updateFile="setNewItem($event)"
									@updateView="onView"
									is-file
									is-readonly
							></field>
						</div>
						<div class="groupField_wrap">
							<field
									:class-error="$v.location && $v.location.$error"
									margin="0 0 10px 0"
									padding="10px 10px 0 10px"
									width="300px"
									label="Location"
									placeholder="Enter location"
									:setInputValue="location"
									@updateInput="onInput($event, 'location')"
									is-textarea
									is-required
							></field>
						</div>
					</div>
				</div>
			</div>
		</div>

		<preview-doc v-if="link" @clear-link="clearLink" :link-doc="link"></preview-doc>
	</dialog-slot>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components

// async components
const PreviewDoc = () => import("@/modules/invoices/preview");
// validate
import { validationMixin } from "vuelidate";
import { minValue, required } from "vuelidate/lib/validators";
// helpers
import { getAppUrl } from "@/services";
import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";

export default {
	name: "AddFuel",
	mixins: [ validationMixin ],
	components: {
		DialogSlot,
		PreviewDoc
	},
	props: {
		currentId: Number,
		getPermissionAction: Boolean,
		permissions: Object
	},
	computed: {
		...mapGetters([ 'fuelPreloader', 'fuel' ]),
		getTitle() {
			return `${ this.currentId ? 'Edit' : 'Create' } fuel bill`;
		},
	},

	data: () => ({
		file: {
			name: "",
			value: ""
		},
		fuel_date: null,
		driverId: 1,
		card: null,
		invoice: null,
		odometr: null,
		city: null,
		state: null,
		fees: null,
		item: null,
		unit: null,
		ppu: null,
		cost: null,
		amt: null,
		discType: null,
		currency: null,
		db: null,
		amount: 0,
		gallons: 0,
		location: '',
		customerName: '',

		link: null,
		drivers: []
	}),
	validations() {
		return {
			fuel_date: { required },
			driverId: { required },
			gallons: { required, minValueValue: minValue(0.1) },
			location: { required },
			amount: { required, minValueValue: minValue(0.1) },
		};
	},
	methods: {
		...mapActions([
			'onFuelCreate',
			'onFuelSave',
			'setAlert',
			'onFuelEdit',
			'onFuelDelete',
			'onInvoiceDelete',
			'getFuelDelete',
			'getInvoiceDelete',
			'onFuelPreloader',
		]),
		setNewItem(e) {
			const iFile = e.target.files[0];
			const reader = new FileReader();

			reader.readAsDataURL(iFile);
			reader.onload = () => {
				this.file = {
					name: iFile.name,
					value: reader.result
				};
			};
		},
		onView() {
			const { value } = this.file;
			this.link = value.includes('data:') ? value : getAppUrl + value;
		},
		clearLink() {
			this.link = null;
		},
		closeDialog() {
			this.$emit('updateClose');
		},
		onInput({ value }, key) {
			this[key] = value;
		},
		async onAutocomplete({ value }, key) {
			this[key] = value?.id ?? value;
			if (key === 'driverId') {
				const { customer, truck_number } = value;

				this.customerName = `${ customer ?? '' } ${ truck_number ?? '' }`;
			}
		},
		onTime(value) {
			this.fuel_date = value;
		},
		getNameFile(fileUrl) {
			if (!fileUrl) return '';
			return fileUrl.split("/").pop();
		},
		async onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const {
					fuel_date,
					driverId,
					card,
					invoice,
					odometr,
					state,
					city,
					fees,
					item,
					unit,
					ppu,
					cost,
					amt,
					discType,
					currency,
					db,
					amount,
					gallons,
					location,
					file
				} = this.$data;
				const values = {
					fuel_date,
					driverId,
					card,
					invoice,
					odometr,
					state,
					city,
					fees,
					item,
					unit,
					ppu,
					cost,
					amt,
					discType,
					currency,
					db,
					amount,
					gallons,
					location,
					file
				};

				await this.onFuelPreloader(true);
				const { status } = await this.onFuelSave({ values, id: this.currentId });

				if (status) {
					this.closeDialog();
					this.$emit('updateFilterList');
					this.setAlert({ type: "success", message: "Saving Successfully" });
					await this.onFuelPreloader(false);
				} else {
					await this.setAlert({ type: "error", message: "Saving error" });
					await this.onFuelPreloader(false);
				}

			} else {
				this.setAlert({ type: "error", message: "Saving error" });
			}
		}
	},
	async mounted() {
		if (this.currentId) {
			await this.onFuelEdit(this.currentId);
		} else {
			await this.onFuelCreate(null);
		}

		const {
			drivers,
			payment
		} = this.fuel;

		this.drivers = drivers;

		if (payment) {
			const {
				fuel_date,
				card,
				invoice,
				odometr,
				state,
				city,
				fees,
				item,
				unit,
				ppu,
				cost,
				amt,
				discType,
				currency,
				db,
				amount,
				gallons,
				location,
				file_check,
				driver_id
			} = payment;

			this.amount = amount;
			this.driverId = driver_id;
			this.fuel_date = fuel_date;
			this.invoice = invoice;
			this.card = card;
			this.odometr = odometr;
			this.state = state;
			this.city = city;
			this.fees = fees;
			this.item = item;
			this.unit = unit;
			this.ppu = ppu;
			this.cost = cost;
			this.amt = amt;
			this.discType = discType;
			this.currency = currency;
			this.db = db;
			this.amount = amount;
			this.gallons = gallons;
			this.location = location;
			this.file.value = file_check;
			this.file.name = this.getNameFile(file_check);

			if (driver_id) {
				const { customer, truck_number } = this.drivers.find(item => item.id === driver_id);
				this.customerName = `${ customer ?? '' } ${ truck_number ?? '' }`;
			}

		}
	}
};
</script>

<style scoped lang="scss">
@import "addFuel";
</style>

<style lang="scss">
@import "addFuelAll";
</style>
